<template>
	<div class="Price-Detail">
		<span style="font-size: 0.16rem; color: gray; font-weight: 700">费用详情</span>
		<el-divider></el-divider>

		<div class="Check-Span">
			<span v-for="(item,index) in stateMaps" :key="index" :class="index === checkIndex ? 'Span-Active':''" @click="changeDetail(item,index)">{{item.stateName}}</span>
		</div>

		<el-table
      :data="stateMapDetails"
			tooltip-effect="light"
			max-height="270"
      style="width: 12rem">
			<el-table-column
				align="center"
				width="150"
				:show-overflow-tooltip="true"
        label="资源名称">
				<template slot-scope="scope">
						<span>{{scope.row.resourceNameCn}}</span>
				</template>
      </el-table-column>
			<el-table-column
				align="center"
				width="150"
				:show-overflow-tooltip="true"
        label="产品名称">
				<template slot-scope="scope">
						<span>{{scope.row.productNameCn}}</span>
				</template>
      </el-table-column>
      <el-table-column
        prop="useDate"
				align="center"
				width="100"
        label="使用日期">
      </el-table-column>
			<el-table-column
        prop="unitPrice"
				align="center"
        label="单价">
				<template slot-scope="scope">
					{{scope.row.currency}}{{scope.row.unitPrice}}
				</template>
      </el-table-column>
			<el-table-column
					prop="rate"
					align="center"
					label="汇率">
			</el-table-column>
			<el-table-column
        prop="priceUnit"
				align="center"
        label="单位">
      </el-table-column>
				<el-table-column
        prop="useTime"
				align="center"
        label="时长">
      </el-table-column>
			<el-table-column
        prop="number"
				align="center"
        label="所需数量">
<!--      </el-table-column>-->
<!--			<el-table-column-->
<!--        prop="allowance"-->
<!--				align="center"-->
<!--        label="剩余数量">-->
      </el-table-column>
			<el-table-column
			  align="center"
				fixed="right"
        label="总价">
				<template slot-scope="scope">
           <span>{{scope.row.currency}}{{(scope.row.unitPrice * scope.row.number).toFixed(2)}}</span>
				</template>
      </el-table-column>
			<el-table-column
			  align="center"
				fixed="right"
        label="是否充足">
				<template slot-scope="scope">
					<span v-if="scope.row.isNotEnough && scope.row.beOverdue" style="color: green;">库存充足</span>
					<span v-else-if="!scope.row.beOverdue && scope.row.isNotEnough" style="color: red;">库存失效</span>
					<span v-else style="color: red">库存不足</span>
				</template>
      </el-table-column>
    </el-table>
<!--		<el-pagination-->
<!--			@current-change="sizeChange"-->
<!--			layout="prev, pager, next"-->
<!--			:page-size="3"-->
<!--			:total="stateMapDetails.length">-->
<!--		</el-pagination>-->
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import {groupBy} from "@/util/arrayGroup";
export default {
	name:  '',
	components: {

	},
	// 定义属性
	data() {
		return {
			checkIndex: 0,
			stateMapDetails: [],
			stateMaps: []
		}
	},
	// 计算属性，会监听依赖属性值随之变化
	computed: {},
	// 监控data中的数据变化
	watch: {
	},
	// 方法集合
	methods: {
		init(stateMaps) {
			console.log(stateMaps,'时刻打开打开');
			this.stateMaps = stateMaps
			this.stateMapDetails = this.stateMaps[0].stateMapDetails
			let groupByData = groupBy(this.stateMaps[0].stateMapDetails,'productType');
			this.generateInventoryPolicyDisplay(groupByData)
		},
		changeDetail(item,index) {
			this.stateMapDetails = item.stateMapDetails
			this.checkIndex = index
			let groupByData = groupBy(item.stateMapDetails,'productType');
			this.$nextTick(() => {
				this.generateInventoryPolicyDisplay(groupByData)
			})
		},

		generateInventoryPolicyDisplay(groupByData) {
			console.log("generateInventoryPolicyDisplay",groupByData)
			let arr = []
			for (let groupByDataKey in groupByData) {
				let obj = {
					productType: groupByDataKey,
					stockIds: groupByData[groupByDataKey].filter(x => Number(x.stockId) > 0).map(x => x.stockId)
				}
				arr.push(obj)
			}
			if (arr.length > 0) {
				this.$emit("inventoryPolicyDisplay", arr)
			}
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {

	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, // 生命周期 - 创建之前
	beforeMount() {}, // 生命周期 - 挂载之前
	beforeUpdate() {}, // 生命周期 - 更新之前
	updated() {}, // 生命周期 - 更新之后
	beforeDestroy() {}, // 生命周期 - 销毁之前
	destroyed() {}, // 生命周期 - 销毁完成
	activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
	.Check-Span {
		>span {
			font-size: 0.15rem;
			color: gray;
			margin-right: 25px;
			&:hover {
				cursor: pointer;
			}
		}
		.Span-Active {
			color: #DD5827;
      border-bottom: 1px solid #DD5827;
			padding-bottom: 3px;
		}
	}
	.el-table {
		position: relative;
    top: 5px;
		/deep/.el-table__header {
			font-size: 12px;
			width: 5rem;
		}
		/deep/ .el-table__body-wrapper {
			overflow-y: scroll;
		}
		/deep/.el-table__fixed-body-wrapper {
			pointer-events: none;
		}
	}

</style>
